import { env } from './env';
import { encode } from 'js-base64';

export function getImgProxyUrl(url: string, width: number, height: number): string {
  if (url.includes('.svg')) {
    return url;
  }
  return [env.IMGPROXY_ENDPOINT, '/sig/resize:fit:', width, ':', height, ':0/', encode(url, true)].join('');
}
